import { Performer } from '../core/performer'
import { HttpMethod } from '../core/types'

export interface BroadcastFilters {
  language: string
  statuses?: string[]
  statusChangedFrom?: string
  statusChangedTo?: string
  noAssessment?: boolean
  chatterIds?: number[]
  limit?: number
  campaignKey?: string
}

export interface BroadcastItem {
  id: number
  message: string
  filters: BroadcastFilters
  status: string
  campaign_key: string | null
  created_at: string
  started_at: string | null
  completed_at: string | null
  total: number
  sent: number
  failed: number
}

export interface BroadcastRecipient {
  id: number
  chatter_id: number
  status: string
  error: string | null
  sent_at: string | null
  chatter: {
    id: number
    name: string | null
    language: string | null
    status: string
    tg_peers: { id: string; username: string | null }[]
  }
}

export interface BroadcastDetails extends BroadcastItem {
  recipients: BroadcastRecipient[]
}

class BroadcastPreview extends Performer<
  { payload: BroadcastFilters },
  { count: number }
> {
  protected method = HttpMethod.POST
  protected url = '/broadcast/preview'
}

class BroadcastSend extends Performer<
  {
    payload: BroadcastFilters & {
      message: string
      sendTest?: boolean
      testNumber?: number
    }
  },
  { broadcastId: number; total: number }
> {
  protected method = HttpMethod.POST
  protected url = '/broadcast/send'
}

class BroadcastList extends Performer<void, BroadcastItem[]> {
  protected method = HttpMethod.GET
  protected url = '/broadcast'
}

class BroadcastDetailsRequest extends Performer<
  { urlParams: { id: number } },
  BroadcastDetails
> {
  protected method = HttpMethod.GET
  protected url = '/broadcast/{id}'
}

class BroadcastRetryFailed extends Performer<
  { urlParams: { id: number } },
  { broadcastId: number; total: number }
> {
  protected method = HttpMethod.POST
  protected url = '/broadcast/{id}/retry-failed'
}

export const broadcastApi = {
  preview: new BroadcastPreview().perform,
  send: new BroadcastSend().perform,
  list: new BroadcastList().perform,
  details: new BroadcastDetailsRequest().perform,
  retryFailed: new BroadcastRetryFailed().perform,
}
